import styled from 'styled-components';
import { PaginationListMixin } from '../../mixins/components/PaginationListMixin';
/**
 * Used by the [`Pagination`](#/More%20components?id=pagination) component as a
 * parent for the buttons and readout text.
 *
 * @component
 * @since 8.0.0
 */

var PaginationList = /*#__PURE__*/styled.ul.withConfig({
  displayName: "PaginationList",
  componentId: "c11n-8-64-0__sc-14rlw6v-0"
})(["", ""], PaginationListMixin);
/** @component */

export default PaginationList;
export var StyledPaginationList = PaginationList;